<template>
  <div flat class="h-100 w-100">
    <b-row no-gutters class="justify-content-end pt-3">
      <button
        v-if="hasRight(Settings.Permission.Change)"
        class="approve btn btn-info waves-effect waves-light mr-2"
        @click="ApproveOrReject(true)"
      >
        {{ t.t(dictEnum.LBL_Approve) }}
      </button>
      <button
        v-if="hasRight(Settings.Permission.Change)"
        class="approve btn btn-danger waves-effect waves-light mr-2"
        @click="ApproveOrReject(false)"
      >
        {{ t.t(dictEnum.LBL_Reject) }}
      </button>
    </b-row>
    <b-row no-gutters class="h-90">
      <b-col cols="4" class="h-100">
        <b-card class="h-100 ml-2">
          <b-row no-gutters class="pt-3">
            <b-col cols="6"> {{ t.t(dictEnum.LBL_Staff) }}</b-col>
            <b-col cols="6">
              <div
                class="d-flex align-center justify-content-between staffInput"
              >
                <div class="pl-2">{{ selectedStaff.StaffID }}</div>
                <button
                  @click="clickStaffTable()"
                  type="button"
                  class="btn btn-transparent p-1 abso-btn"
                >
                  <img
                    src="../../../../../static/images/search.png"
                    class="w-14"
                  />
                </button>
              </div>
            </b-col>
          </b-row>
          <b-row no-gutters class="pt-3">
            <b-col cols="6"> {{ t.t(dictEnum.LBL_Department) }} </b-col>
            <b-col cols="6">
              {{ staffFinalDetail.Dept }}
            </b-col>
          </b-row>
          <b-row no-gutters class="pt-3">
            <b-col cols="6">{{ t.t(dictEnum.LBL_Title) }} </b-col>
            <b-col cols="6"> {{ staffFinalDetail.Title }}</b-col>
          </b-row>
          <b-row no-gutters class="pt-3">
            <b-col cols="6">{{ t.t(dictEnum.LBL_DateJoin) }}</b-col>
            <b-col cols="6">
              {{
                staffFinalDetail.DateJoin | moment(Settings.DateTime.yyyymmdd)
              }}
            </b-col>
          </b-row>
          <b-row no-gutters class="pt-3">
            <b-col cols="6">{{ t.t(dictEnum.LBL_YOS) }}</b-col>
            <b-col cols="6">{{ staffFinalDetail.YOS }}</b-col>
          </b-row>
          <b-row no-gutters class="pt-3">
            <b-col cols="6">{{ t.t(dictEnum.LBL_EmpType) }}</b-col>
            <b-col cols="6">{{ staffFinalDetail.EmployType }}</b-col>
          </b-row>
          <b-row no-gutters class="pt-3">
            <b-col cols="6">{{ t.t(dictEnum.LBL_PayType) }}</b-col>
            <b-col cols="6">{{ staffFinalDetail.PayType }}</b-col>
          </b-row>
          <b-row no-gutters class="pt-3">
            <b-col cols="6">{{ t.t(dictEnum.LBL_Salary) }}</b-col>
            <b-col cols="6">
              {{ staffFinalDetail.Salary | toFixedDecimal }}
            </b-col>
          </b-row>
          <b-row no-gutters class="pt-3">
            <b-col cols="6">{{ t.t(dictEnum.LBL_DateLastWork) }}</b-col>
            <b-col cols="6">
              <date-picker
                id="DateLastWork"
                :placeholder="t.t(dictEnum.LBL_DateLastWork)"
                v-model="selectedStaff.DateLastWork"
                disabled
                :lang="lang"
                type="date"
                format="YYYY-MM-DD"
                v-bind:editable="false"
                v-bind:clearable="false"
              ></date-picker>
            </b-col>
          </b-row>
          <b-row no-gutters class="pt-3">
            <b-col cols="6">{{ t.t(dictEnum.LBL_DailyWage) }}</b-col>
            <b-col cols="6">{{ staffFinalDetail.DailyRate }}</b-col>
          </b-row>
          <b-row no-gutters class="pt-3">
            <b-col cols="6">{{ t.t(dictEnum.LBL_AL) }}</b-col>
            <b-col cols="6">{{ staffFinalDetail.AnnualLeave }}</b-col>
          </b-row>
          <b-row no-gutters class="pt-3">
            <b-col cols="6">{{ t.t(dictEnum.LBL_CL) }}</b-col>
            <b-col cols="6">{{ staffFinalDetail.CompensationLeave }}</b-col>
          </b-row>
          <b-row no-gutters class="d-flex justify-content-center">
            <button
              style="position:absolute;bottom:10px;"
              class="approve btn btn-primary waves-effect waves-light mr-2"
              @click="getFinalDetail()"
            >
              {{ t.t(dictEnum.LBL_SearchStaff) }}
            </button>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="8" class="h-100" v-if="staffFinalDetail.StaffID">
        <div class="detailCard h-100">
          <b-row no-gutters class="head">
            {{ staffFinalDetail.StaffName }}
          </b-row>
          <b-row no-gutters class="tableTitle">
            {{ t.t(dictEnum.LBL_Payroll) }}
          </b-row>
          <b-row no-gutters class="tableBody">
            <div class="h-100 w-100">
              <table class="w-100">
                <tr>
                  <td colspan="4">{{ t.t(dictEnum.LBL_Salary) }}()</td>
                  <td class="text-right">
                    {{ staffFinalDetail.AtuSalary | toFixedDecimal }}
                  </td>
                  <td></td>
                  <td class="text-right">
                    {{ staffFinalDetail.AtuSalary | toFixedDecimal }}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="4">
                    {{ t.t(dictEnum.LBL_Addition) }}: {{ t.t(dictEnum.LBL_AL) }}
                  </td>
                  <td class="text-right">
                    {{ staffFinalDetail.AnnualLeaveTotal | toFixedDecimal }}
                  </td>
                  <td></td>
                  <td class="text-right">
                    {{ TotalAL() | toFixedDecimal }}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="4">
                    {{ t.t(dictEnum.LBL_Addition) }}: {{ t.t(dictEnum.LBL_CL) }}
                  </td>
                  <td class="text-right">
                    {{
                      staffFinalDetail.CompensationLeaveTotal | toFixedDecimal
                    }}
                  </td>
                  <td></td>
                  <td class="text-right">
                    {{ TotalCL() | toFixedDecimal }}
                  </td>
                  <td></td>
                </tr>
                <tr class="tableTh">
                  <th>{{ t.t(dictEnum.LBL_Adjustment) }}</th>
                  <th>{{ t.t(dictEnum.LBL_Type) }}</th>
                  <th>{{ t.t(dictEnum.LBL_Particular) }}</th>
                  <th class="text-right">{{ t.t(dictEnum.LBL_Addition) }}</th>
                  <th class="text-right">{{ t.t(dictEnum.LBL_Deduct) }}</th>
                  <th class="text-right">{{ t.t(dictEnum.LBL_Balance) }}</th>
                  <th></th>
                </tr>
                <tr
                  v-for="(cal, calIndex) in staffFinalDetail.salaryAdjs"
                  :key="calIndex"
                >
                  <td>{{ cal.AdjAdd ? "+" : "-" }}</td>
                  <td>{{ cal.IncSubType }}</td>
                  <td class="text-center">
                    {{ cal.DateTx | moment(Settings.DateTime.yyyymmdd) }}
                  </td>
                  <td>{{ cal.Particulars }}</td>
                  <td class="text-right">
                    {{ cal.AdjAdd ? cal.Amt : 0 | toFixedDecimal }}
                  </td>
                  <td class="text-right">
                    {{ cal.AdjAdd ? 0 : cal.Amt | toFixedDecimal }}
                  </td>
                  <td class="text-right">
                    {{ Balance(calIndex) | toFixedDecimal }}
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="5">
                    {{ t.t(dictEnum.LBL_MPF) }}
                  </td>
                  <td class="text-right">
                    {{ staffFinalDetail.LessMPF | toFixedDecimal }}
                  </td>
                  <td class="text-right">
                    {{
                      (Balance(staffFinalDetail.salaryAdjs.length) -
                        staffFinalDetail.LessMPF)
                        | toFixedDecimal
                    }}
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="text-right">
                    {{ t.t(dictEnum.LBL_Net) }}:
                    {{
                      (Balance(staffFinalDetail.salaryAdjs.length) -
                        staffFinalDetail.LessMPF)
                        | toFixedDecimal
                    }}
                  </td>
                </tr>
              </table>
            </div>
          </b-row>
          <b-row no-gutters class="justify-content-center pt-3 pb-3">
            <b-col cols="6">
              <date-picker
                id="DateLastPay"
                v-model="staffFinalDetail.DateLastPay"
                :lang="lang"
                type="date"
                format="YYYY-MM-DD"
                v-bind:editable="false"
                v-bind:clearable="false"
              ></date-picker>
            </b-col>
          </b-row>
          <b-row no-gutters class="justify-content-center">
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                v-model="staffFinalDetail.payMethod"
                :options="payMethodList"
                text-field="Method"
                value-field="Method"
                plain
                :aria-describedby="ariaDescribedby"
              ></b-form-radio-group>
            </b-form-group>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-modal
      size="lg"
      hide-footer
      id="StaffTable"
      :title="t.t(dictEnum.LBL_Staff)"
    >
      <b-row no-gutters>
        <b-form-input
          size="sm"
          v-model="searchRec"
          :placeholder="t.t(dictEnum.LBL_SearchStaff)"
        ></b-form-input>
      </b-row>
      <div class="staffTable">
        <b-table
          :items="staffs"
          :fields="staffFields"
          :tbody-tr-class="rowClass"
          @row-clicked="OnStaffSelect"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template #cell(EName)="data">
            {{ data.item.EngName + " " + data.item.EngLastName }}
          </template>
          <template #cell(CName)="data">
            {{ data.item.ChiLastName + data.item.ChiName }}
          </template>
        </b-table>
      </div>
      <b-row no-gutters class="pt-3">
        <b-pagination
          first-number
          last-number
          limit="10"
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="staffs.length"
        ></b-pagination>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import StoreGetter from "@/constants/StoreGetter";
import Settings from "@/constants/Settings";
import SweetAlertService from "@/service/SweetAlertService";
import PayProfileService from "@/service/PayProfileService";
import PayMethodService from "@/service/PayMethodService";
import PayrollAdjustmentService from "@/service/PayrollAdjustmentService";
import FinalPaymentService from "@/service/FinalPaymentService";
import { SalayAdj } from "@/model/SalayAdj";
import { GlobalMixin } from "@/common/mixin/GlobalMixin";
import { FinalPayment } from "@/model/FinalPayment";
import UserService from "@/service/UserService";
export default {
  name: "FinalPayment",
  components: {
    DatePicker,
    moment
  },
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    isEng() {
      return this.$store.getters[StoreGetter.user].Lang == "EN";
    },
    staffs() {
      let list = this.staffList;
      if (this.searchRec) {
        list = list.filter(x => ArrayHelper.wildCardSearch(x, this.searchRec));
      }
      return list;
    }
  },
  data() {
    return {
      ...GlobalMixin,
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.PayrollApproval,
      selectedStaff: {},
      currentPage: 1,
      perPage: 18,
      payMethodList: [],
      incTypeList: [],
      staffList: [],
      staffFields: [
        {
          key: "StaffID",
          label: t.t(dictEnum.LBL_ID),
          thStyle: { width: "30%" }
        },
        {
          key: "EName",
          label: t.t(dictEnum.LBL_EngName),
          thStyle: { width: "35%" }
        },
        {
          key: "CName",
          label: t.t(dictEnum.LBL_ChiName),
          thStyle: { width: "35%" }
        }
      ],
      staffFinalDetail: new FinalPayment(),
      selectedAdjustment: new SalayAdj(),
      searchRec: ""
    };
  },

  mounted() {
    this.assignRights();
    this.getPayMethodList();
    this.getIncTypeList();
  },

  methods: {
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];

      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.StaffID == this.selectedStaff.StaffID) {
        return "selected-tr";
      }
    },

    async getStaffPerPage() {
      this.$forceUpdate();
      const tableEle = await document.getElementsByClassName("staffTable");
      const tableHeight = await tableEle[0].offsetHeight;
      const trEle = await tableEle[0].children[0].children;
      if (trEle.length > 1) {
        const thHeight = await trEle[0].offsetHeight;
        const tdHeight = await trEle[1].children[0].offsetHeight;
        let page = (tableHeight - thHeight * 2.5) / tdHeight;
        this.perPage = page.toFixed(0);
      }
    },

    async getIncTypeList() {
      const obj = {};
      const response = await PayrollAdjustmentService.getIncTypeList(obj);
      if (response.data.IsSuccess) {
        this.incTypeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getPayMethodList() {
      var obj = {};
      const response = await PayMethodService.getAllPayMethod(obj);
      if (response.data.IsSuccess) {
        this.payMethodList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async getStaffList() {
      var obj = {
        searchText: "",
        sortField: "",
        isInResigneUser: false
      };
      const response = await UserService.getUsers(obj);
      if (response.data.IsSuccess) {
        this.staffList = response.data.Data;
        this.getStaffPerPage();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    clickStaffTable() {
      this.$bvModal.show("StaffTable");
      this.getStaffList();
    },

    OnStaffSelect(item) {
      this.selectedStaff = item;
      this.$bvModal.hide("StaffTable");
    },

    async getFinalDetail() {
      if (!this.selectedStaff.StaffID) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_Staff) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      if (!this.selectedStaff.DateLastWork) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_DateLastWork) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      const dateLastWork = moment(this.selectedStaff.DateLastWork).format(
        Settings.DateTime.yyyymmdd
      );
      const response = await FinalPaymentService.getFinalPayment(
        this.selectedStaff.StaffID,
        dateLastWork
      );
      if (response.data.IsSuccess) {
        this.staffFinalDetail = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async ApproveOrReject(bol) {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${bol ? t.t(dictEnum.LBL_Approve) : t.t(dictEnum.LBL_Reject)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const response = await FinalPaymentService.ApproveOrReject(
          this.staffFinalDetail.txNum,
          this.staffFinalDetail.Status,
          this.staffFinalDetail.StaffID
        );
        if (response.data.IsSuccess) {
          this.getFinalDetail();
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    TotalAL() {
      const total =
        this.staffFinalDetail.AtuSalary +
        this.staffFinalDetail.AnnualLeaveTotal;
      return total;
    },

    TotalCL() {
      const alTotal = this.TotalAL();
      return alTotal + this.staffFinalDetail.CompensationLeaveTotal;
    },

    Balance(index) {
      let LeaveBal = this.TotalCL();
      let num = 0;
      if (this.staffFinalDetail.salaryAdjs.length > 0) {
        const list = this.staffFinalDetail.salaryAdjs.filter(
          (x, i) => i <= index
        );
        for (let data of list) {
          const amt = Number(data.Amt);
          if (data.AdjAdd) {
            num += amt;
          } else {
            num -= amt;
          }
        }
      }
      num += LeaveBal;
      return num;
    }
  }
};
</script>
<style scoped lang="scss">
.staffInput {
  border: 1px solid;
  height: 100%;
}

.detailCard {
  background: white;
  margin-left: 10px;
  .head {
    padding: 15px;
  }

  .tableTh {
    th {
      color: white !important;
    }
    background: #81afbd;
  }

  .tableTitle {
    padding: 15px;
    background-color: #5ba7be;
    color: white;
  }

  .tableBody {
    height: 70%;
  }
}

.staffTable {
  height: 85%;
  overflow-y: auto;
}
>>> .modal-dialog.modal-lg {
  height: 90%;
}

>>> .modal-content {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/100000-Payroll/104000-PayrollApproval/FinalApproval/FinalApproval.vue